import { css } from 'fe-styled-components';

/**
 * Base Button CSS
 */
const baseCss = css`
  position: relative;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif; /* @TODO get from theme */
  display: inline-block;
  text-decoration: none;
  font-weight: 400; /* @TODO get from theme */
  vertical-align: middle;
  border: 1px solid transparent;
  /* box-shadow: 0 1px 0 0 rgba(255, 255, 255, .15) inset; */
  line-height: 1.3; /* @TODO get from theme */
  border-radius: 4px; /* @TODO get from theme */
  transition: color 0.15s ease-out, background-color 0.15s ease-out,
    border-color ease-out 0.25s;
  cursor: pointer;
`;

/**
 * Default type CSS
 */
const defaultCss = css`
  background-color: #333; /* @TODO get from theme */
  border-color: #333; /* @TODO get from theme */
  color: #fff;

  &:hover {
    background-color: #1a1a1a;
    border-color: #141414;
  }
`;

/**
 * CTA type CSS
 */
const ctaCss = css`
  background-color: #8dc63f; /* @TODO get from theme */
  border-color: #8dc63f; /* @TODO get from theme */

  &:hover {
    background-color: #72a230;
    border-color: #6c9a2e;
  }
`;

/**
 * Ghost type CSS
 */
const primaryCss = css`
  background-color: #00aeef; /* @TODO get from theme */
  border-color: #00aeef; /* @TODO get from theme */

  &:hover {
    background-color: #0089bc;
    border-color: #0081b2;
  }
`;

/**
 * Ghost type CSS
 */
const standardCss = css`
  background-color: #fff; /* @TODO get from theme */
  border-color: #ccc; /* @TODO get from theme */
  color: #333; /* @TODO get from theme */
  font-weight: 600;

  &:hover {
    color: #00aeef;
    background-color: #fff;
    border-color: #00aeef;
  }
`;

/**
 * Ghost type CSS
 */
const ghostCss = css`
  background-color: transparent;
  border-color: #fff; /* @TODO get from theme */
  color: #fff; /* @TODO get from theme */
  font-weight: 600;

  &:hover {
    color: #00aeef;
    background-color: #fff;
    border-color: #fff;
  }
`;

const smCss = css`
  padding: 6px 16px;
  font-size: 14px;
`;
const mdCss = css`
  padding: 10px 20px;
  font-size: 16px;
`;
const lgCss = css`
  padding: 14px 24px;
  font-size: 18px;
`;

/**
 * Returns button type styled CSS
 * @param {string} variation
 * @return {string}
 */
const getVariant = (variation) => {
  let style;

  switch (variation) {
    case 'cta':
      style = ctaCss;
      break;
    case 'primary':
      style = primaryCss;
      break;
    case 'standard':
      style = standardCss;
      break;
    case 'ghost':
      style = ghostCss;
      break;
    default:
      style = defaultCss;
      break;
  }

  return style;
};

/**
 * Returns button type styled CSS
 * @param {string} variation
 * @return {string}
 */
const getSize = (size) => {
  let style;

  switch (size) {
    case 'sm':
      style = smCss;
      break;
    case 'lg':
      style = lgCss;
      break;
    default:
      style = mdCss;
      break;
  }

  return style;
};

const buttonCss = (props) => {
  const { type, size } = props;
  const variationCss = getVariant(type);
  const sizeCss = getSize(size);

  return `
    ${baseCss}
    ${sizeCss}
    ${variationCss}
  `;
};

export { buttonCss };
